import React from 'react';
import PanelSection from 'components/v2/PanelSection';
import CardFooter from 'components/v2/card/CardFooter';
import PropTypes from 'prop-types';
export default function ListItemForm({ children, onActionClick, onCancelClick, actionLabel, cancelLabel, showCancelButton, cancelLink, buttonsDisabled = false, actionTestDataId, cancelTestDataId, }) {
    return (React.createElement("div", null,
        React.createElement(PanelSection, { className: "mb-4" }, children),
        React.createElement(CardFooter, { onActionClick: onActionClick, onCancelClick: onCancelClick, actionLabel: actionLabel, cancelLabel: cancelLabel, cancelLink: cancelLink, showCancelButton: showCancelButton, disabled: buttonsDisabled, actionTestDataId: actionTestDataId, cancelTestDataId: cancelTestDataId })));
}
ListItemForm.propTypes = {
    children: PropTypes.node,
    onActionClick: PropTypes.func,
    onCancelClick: PropTypes.func,
    actionLabel: PropTypes.string,
    cancelLabel: PropTypes.string,
    cancelLink: PropTypes.string,
    showCancelButton: PropTypes.bool,
    buttonsDisabled: PropTypes.bool,
};
ListItemForm.defaultProps = {
    showCancelButton: true,
    buttonsDisabled: false,
};
